export default __webpack_public_path__ + "static/media/Page15.e958f4ba.txt";